import windowReducer from '@/redux/slice/windowSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import receiverCountReducer from './slice/receiverCountSlice';
import tokenReducer from './slice/tokenSlice';

// Safe storage that won't fail during SSR
const createNoopStorage = () => ({
  getItem: (_key: string) => Promise.resolve(null),
  setItem: (_key: string, value: string) => Promise.resolve(value),
  removeItem: (_key: string) => Promise.resolve()
});
const storage = typeof window !== 'undefined' ? createWebStorage('local') // real localStorage on client
: createNoopStorage(); // noop on server

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['windows', 'token']
};
const rootReducer = combineReducers({
  windows: windowReducer,
  receiverCount: receiverCountReducer,
  token: tokenReducer
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  })
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;